import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDrawer4"><Path fillRule="evenodd" clipRule="evenodd" d="M11 4H2V17H4L4 20H6L6 17H11V4ZM9 12V8H7V12H9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13 17H18V20H20V17H22V4H13V17ZM17 12V8H15V12H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer4;
